import loadable from '@loadable/component';

export const SalariesExplorePageAuthLoadable = loadable(
  () => import('./SalariesExplorePageAuth'),
  { resolveComponent: (module) => module.SalariesExplorePageAuth },
);
